import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { IFireAgency } from 'src/models/fire-agency.model';
import services from 'src/services/fire-agency.service';

export const actionTypes = {
  FIRE_AGENCY_FETCH: 'FIRE_AGENCY_FETCH',
  FIRE_AGENCY_ADD: 'FIRE_AGENCY_ADD',
  FIRE_AGENCY_UPDATE: 'FIRE_AGENCY_UPDATE',
  FIRE_AGENCY_DELETE: 'FIRE_AGENCY_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.FIRE_AGENCY_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.FIRE_AGENCY_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.FIRE_AGENCY_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.FIRE_AGENCY_DELETE,
    service: services.itemDELETE,
  },
};

export type IFireAgencyAsync = typeof asyncActions;

export interface IFireAgencyState extends ICommonState<IFireAgencyAsync> {
  data?: IFireAgency;
  list: IFireAgency[];
  total: number;
}

export const defaultState: IFireAgencyState = {
  status: {},
  list: [],
  total: 0,
};

const FireAgencyReducer = (
  state: IFireAgencyState = defaultState,
  action: IReducerAction<IFireAgencyAsync>
): IFireAgencyState => {
  switch (action.type) {
    case actionTypes.FIRE_AGENCY_FETCH: {
      return {
        ...state,
        list: action.payload?.fireAgencies.rows ?? [],
        total: action.payload?.fireAgencies.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default FireAgencyReducer;
